import React, { useState } from 'react';
import { Tooltip, Row, Col } from 'antd';
import copy from 'copy-to-clipboard';

const CopyLink = ({ text = 'Copy Link', value = null }) => {
	const [visible, setvisible] = useState(false);
	const handleCopy = () => {
		setvisible(true);
		copy(value);
		setTimeout(() => {
			setvisible(false);
		}, 1000);
	};
	return (
		<Col className="custom_copy_link">
			<Tooltip placement="topLeft" color="#EB8601" visible={visible} title={`${value} copied!`}>
				<Col className="card_value copy_link" onClick={handleCopy}>
					{text}
				</Col>
			</Tooltip>
		</Col>
	);
};

export default CopyLink;
